import Vue from "vue";
import Vuex from "vuex";

import trader from "./trader.module";
import user from "./user.module";
import strategy from "./strategy.module";
import account from "./account.module";
import subscription from "./subscription.module";
import terminal from "./terminal.module";
import command from "./command.module";
import mixin from "./mixin.module";
import plan from "./plan.module";
import sale from "./sale.module";
import schema from "./schema.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    strategy,
    account,
    subscription,
    trader,
    terminal,
    command,
    mixin,
    plan,
    sale,
    schema
  }
});
